import type { Schema } from '@cli-types/core-engine/schema.js'
import { SAMPLE_UUID } from '@cli-constants/generators.js'
import { getManyToManyFields } from '@core-engine/schema/field-helpers/flattening/get-many-to-many-fields.js'
import { isUserRelationshipTarget } from '@core-engine/schema/system-relationships/is-user-relationship-target.js'
import { getEntityFieldContext } from '@next-adapter/generators/entity-filters/get-entity-field-context.js'
import { addFormattedTimestamps } from './add-formatted-timestamps.js'
import { getHtmlOutputFields } from './get-html-output-fields.js'
import { sampleAdminMedia } from './sample-admin-media.js'
import { sampleAdminUserSummary } from './sample-admin-user-summary.js'
import { sampleSchemaFieldValue } from './sample-schema-field-value.js'
import { sampleSchemaOutputValue } from './sample-schema-output-value.js'
export function createEntityDataObject(schema: Schema): Record<string, unknown> {
  const { allDbFields, regularDbFields } = getEntityFieldContext(schema)
  const htmlOutputFields = getHtmlOutputFields(regularDbFields)
  const manyToManyFields = getManyToManyFields(schema.fields)
  const mediaFields = regularDbFields.filter((field) => {
    return field.type === 'image' || field.type === 'video' || field.type === 'media'
  })
  const galleryFields = regularDbFields.filter((field) => field.type === 'gallery')

  return addFormattedTimestamps({
    ...Object.fromEntries(allDbFields.map((field) => [field.name, sampleSchemaOutputValue(field)])),
    ...Object.fromEntries(
      htmlOutputFields.map((field) => [
        `${field.name}Html`,
        `<p>${sampleSchemaFieldValue(field)}</p>`
      ])
    ),
    ...Object.fromEntries(
      manyToManyFields.map((field) => [
        field.name,
        isUserRelationshipTarget(field.relationship) ? ['user-id'] : [SAMPLE_UUID]
      ])
    ),
    ...Object.fromEntries(mediaFields.map((field) => [`${field.name}Media`, sampleAdminMedia()])),
    ...Object.fromEntries(
      galleryFields.map((field) => [`${field.name}Media`, [sampleAdminMedia()]])
    ),
    createdByUser: sampleAdminUserSummary(),
    updatedByUser: sampleAdminUserSummary()
  })
}
